import Vue from "vue"
import Vuex from "vuex"
import * as _ from "lodash";
import {Plex} from "@/shared/DataService/plex";
import AppSettings from "@/shared/Configuration/appSettings";
import HistoryStack from "@/store/historyStack";
import {IRootModel} from "@/shared/models/abstract/IRootModel";
import RecentStack from "@/store/recentStack";

Vue.use(Vuex);
const history = new HistoryStack<IRootModel>();
const recent = new RecentStack();
export default new Vuex.Store({
    state: {
        settings: {},
        selectedModel: null,
        plex: null,
        error: null,
        history: [],
        recent: []
    },
    mutations: {
        upsertSettings(state, settings) {
            state.settings = settings;
        },
        selectedModel(state, data) {

            state.selectedModel = data;
        },
        updateProperty(state, {propertyName, value}) {
            if (_.isNil(state.selectedModel)) {
                return;
            }
            state.selectedModel[propertyName] = value;
        },
        setError(state, error) {
            state.error = error;
        },
        upsertPlex(state, plex) {
            if (plex instanceof Plex) {
                state.plex = plex;
                console.info(`Active Plex: ${plex.name} (${plex.nodes.length} nodes).`)
            } else {
                throw new Error("Expected a Plex type.")
            }
        },
        removeFromHistory(state, entity) {

            history.remove((item: IRootModel) => {
                return item.id === entity.id;
            });
            history.getAll().forEach(item => state.history.push(item));
        },
        removeFromRecent(state, entity) {
            recent.remove((item: IRootModel) => {
                return item.id === entity.id;
            });
            // cannot assign directly or the mutation mechanics won't work
            state.recent.length = 0;
            recent.getAll().forEach(item => state.recent.push(item));
        },
        backwardInHistory(state) {
            history.backward();
        },
        forwardInHistory(state) {
            history.forward();
        },
        pushInHistory(state, entity) {
            // only push if it's different from the current one
            if (!_.isNil(entity)) {
                const item = history.current;
                if (!_.isNil(item)) {
                    if (item.id !== entity.id) {
                        history.push(entity);
                    }
                } else {
                    history.push(entity);
                }
            }
            state.recent.length = 0;
            recent.getAll().forEach(item => state.recent.push(item));
        },
        setRecent(state, items) {
            state.recent.length = 0;
            recent.push(...items);
            recent.getAll().forEach(item => state.recent.push(item));
        },
        addRecent(state, item) {
            state.recent.length = 0;
            recent.push(item);
            recent.getAll().forEach(item => state.recent.push(item));
        }
    },
    actions: {
        selectedModel({commit, state}, item) {
            commit("selectedModel", item);
        },
        upsertPlex({commit, state}, plex) {
            commit("upsertPlex", plex);
        },
        updateProperty({commit, state}, {propertyName, value}) {
            commit("updateProperty", {propertyName, value});
        },
        upsertSettings({commit, state}, settings) {
            if (settings instanceof AppSettings) {
                commit("upsertSettings", settings);
            } else {
                throw new Error("Expected AppSettings instance to update the settings.");
            }
        },
        setError({commit}, error) {
            commit("setError", error);
        },
        backwardInHistory({commit}) {
            commit("backwardInHistory");
        },
        forwardInHistory({commit}) {
            commit("forwardInHistory");
        },
        pushInHistory({commit}, entity) {
            commit("pushInHistory", entity);
        },
        setRecent({commit}, items) {
            commit("setRecent", items);
        },
        addRecent({commit}, item) {
            commit("addRecent", item);
        },
        removeFromHistory({commit}, item) {
            commit("removeFromHistory", item);
        },
        removeFromRecent({commit}, item) {
            commit("removeFromRecent", item);
        }
    },
    getters: {
        current: state => {
            return history.current;
        }
    },
    modules: {}
})
